// Short notification "beep" via the Web Audio API — no audio asset, nothing
// loaded from a CDN, works offline. A single shared AudioContext is created
// lazily and resumed on demand: browsers start it 'suspended' until a user
// gesture, but by the time an admin has clicked around the dashboard it resumes
// fine. Playback is best-effort and never throws into the caller (the poller).
let ctx = null;

const getCtx = () => {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

export const playBeep = () => {
  try {
    const audio = getCtx();
    if (!audio) return;
    if (audio.state === 'suspended') audio.resume().catch(() => {});

    const now = audio.currentTime;
    // Two quick rising tones — a recognizable "new ticket" chirp.
    [
      {freq: 880, at: 0}, // A5
      {freq: 1175, at: 0.16}, // D6
    ].forEach(({freq, at}) => {
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      // Quick fade in/out so it doesn't click.
      gain.gain.setValueAtTime(0.0001, now + at);
      gain.gain.exponentialRampToValueAtTime(0.14, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.14);
      osc.connect(gain);
      gain.connect(audio.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.15);
    });
  } catch {
    // Audio is best-effort — swallow anything (autoplay policy, no AudioContext).
  }
};
